import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const OurValues = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t, i18n } = useTranslation();

  const isRTL = i18n.dir() === 'rtl';
  const fontFamily = isRTL ? "'Tajawal', Arial, sans-serif" : "Arial, Helvetica, sans-serif";
  const textAlign = isRTL ? 'right' : 'left';

  const values = [
    {
      title: t("Value1"),
      description: t("ValueD1"),
    },
    {
      title: t("Value2"),
      description: t("ValueD2"),
    },
    {
      title: t("Value3"),
      description: t("ValueD3"),
    },
    {
      title: t("Value4"),
      description: t("ValueD4"),
    },
     {
      title: t("Value5"),
      description: t("ValueD5"),
    },
  ];

  const textStyle = {
    fontFamily,
    fontSize: isMobile ? '2rem' : '3rem',
    color: '#fff',
    textShadow:
      '0 0 5px rgb(0, 162, 255), 0 0 10px rgb(36, 60, 196), 0 0 20px rgb(34, 130, 185), 0 0 40px rgb(28, 86, 161), 0 0 80px rgb(214, 187, 197)',
    animation: 'glow 1.5s infinite alternate',
    textAlign,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        px: { xs: 2, md: 8 },
        py: 4,
        gap: 4,
        background: 'white',
        alignItems: isMobile ? 'center' : 'flex-start',
        direction: isRTL ? 'rtl' : 'ltr',
        fontFamily,
      }}
    >
      {/* Left Title with Flag */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          pt: isMobile ? 0 : 11,
        }}
      >
        <Box
          sx={{
            width: 0,
            height: 0,
            borderTop: '20px solid transparent',
            borderBottom: '20px solid transparent',
            borderLeft: '20px solid #0C2182',
            mr: 1,
          }}
        />

        {/* Glow animation keyframes */}
        <style>
          {`
            @keyframes glow {
              0% {
                text-shadow: 0 0 5px rgb(0, 153, 255), 0 0 10px #0C2182, 0 0 20px #0C2182, 0 0 40px #0C2182, 0 0 80px #0C2182;
              }
              100% {
                text-shadow: 0 0 10px #0C2182, 0 0 20px #0C2182, 0 0 40px #0C2182, 0 0 80px #0C2182, 0 0 160px #0C2182;
              }
            }
          `}
        </style>

        <Typography component="h1" style={textStyle}>
          {t("titleValue")}
        </Typography>
      </Box>

      {/* Accordion List */}
      <Stack spacing={0} flex={1} sx={{ width: '100%' }}>
        {values.map((val, index) => (
          <Accordion
            key={index}
            disableGutters
            elevation={0}
            square
            sx={{
              borderBottom: '1px solid #e0e0e0',
              '&:before': { display: 'none' },
              direction: isRTL ? 'rtl' : 'ltr',
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
              sx={{
                px: 0,
                py: 2,
                minHeight: '48px',
                '& .MuiAccordionSummary-content': {
                  margin: 0,
                  fontWeight: 500,
                  fontSize: '1.15rem',
                  fontFamily,
                  textAlign,
                },
              }}
            >
              <Typography sx={{ fontFamily, textAlign, width: '100%' }}>
                {val.title}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ px: 0, pt: 0, pb: 2 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontFamily, textAlign }}
              >
                {val.description}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </Box>
  );
};

export default OurValues;
